<template>
  <div class="widget">
    <form
      :action="link"
      method="POST"
      encType="application/x-www-form-urlencoded"
      target="widgetFrame"
      name="widgetLaunchForm"
      ref="form"
    >
      <input
        v-for="(value, name) in inputs"
        :key="name"
        :name="name"
        :value="value"
        type="hidden"
      />
      <input
        name="oauth_signature"
        :value="signature"
        type="hidden"
      />
    </form>
    <iframe class="w-full h-full" name="widgetFrame" :src="`https://www.bookwidgets.com/play/${link}`"></iframe>
  </div>
</template>

<script>
import signature from 'oauth-signature';

export default {
  name: 'BookWidgetFrame',

  props: {
    link: String,
  },

  data() {
    return {
      user: {
        email: 'test@niepodam.pl',
        first_name: 'Jan',
        last_name: 'Kowalski',
      },
      inputs: {
        lti_message_type: 'basic-lti-launch-request',
        lti_version: 'LTI-1p0',
        user_id: 292832126,
        roles: 'Student',
        tool_consumer_instance_name: 'earlystage_online',
        context_title: 'Praca domowa',
        launch_presentation_locale: 'pl',
        oauth_consumer_key: process.env.VUE_APP_BOOKWIDGETS_CONSUMER_KEY,
        oauth_signature_method: 'HMAC-SHA1',
        oauth_version: '1.0',
        oauth_timestamp: '',
        oauth_nonce: '',
        lis_person_contact_email_primary: '',
        lis_person_contact_name_family: '',
        lis_person_contact_name_given: '',
      },
    };
  },

  computed: {
    signature() {
      return signature.generate('POST', this.link, this.inputs, process.env.VUE_APP_BOOKWIDGETS_CONSUMER_SECRET, null, {
        encodeSignature: false,
      });
    },
  },

  mounted() {
    this.launchLti();
  },

  methods: {
    generateNonce() {
      return Math.random().toString(36).substring(2, 15)
        + Math.random().toString(36).substring(2, 15);
    },

    launchLti() {
      this.inputs.oauth_nonce = this.generateNonce();
      this.inputs.lis_person_contact_email_primary = this.user.email;
      this.inputs.lis_person_contact_name_given = this.user.first_name;
      this.inputs.lis_person_contact_name_family = this.user.last_name;
      this.inputs.oauth_timestamp = Math.floor(Date.now() / 1000);

      this.$nextTick(() => {
        // this.$refs.form.submit();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .widget {
    height: calc(100% - 122px);

    @media screen and (min-width: 768px) {
      height: calc(100% - 112px);
    }
    }
</style>
